"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_LAYER_SLOTS = void 0;
exports.assignLayer = assignLayer;
exports.removeLayer = removeLayer;
const constants_1 = require("./constants");
exports.EMPTY_LAYER_SLOTS = new Array(constants_1.ANIMATION_LAYER_DEPTH).fill(undefined);
/**
 * Place a layer in the slots array. If a layer with the same name already
 * occupies a slot, replace it in-place - that keeps the slot stable so the
 * animation doesn't jump between DOM nodes when other layers come and go.
 * Otherwise the layer takes the first empty slot. If every slot is full the
 * layer is dropped.
 */
function assignLayer(prev, layer) {
    const next = [...prev];
    const existingIdx = next.findIndex((l) => (l === null || l === void 0 ? void 0 : l.name) === layer.name);
    if (existingIdx !== -1) {
        next[existingIdx] = layer;
        return next;
    }
    const emptyIdx = next.findIndex((l) => l === undefined);
    if (emptyIdx !== -1) {
        next[emptyIdx] = layer;
    }
    return next;
}
function removeLayer(prev, name) {
    return prev.map((l) => ((l === null || l === void 0 ? void 0 : l.name) === name ? undefined : l));
}
